import apiSlice from "./apiSlice";
const packagesSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllIssue: builder.query({
            query: (req) => ({
                url: `issues`,
                params: req
            }),
            providesTags:['GetAllIssueTag'],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getPackages: builder.query({
            query: ({ projectId, type }) => {
                const params = new URLSearchParams();
                if (projectId) params.append("projectId", projectId);
                if (type) params.append("type", type);
                return `WBS?${params.toString()}`;
            },
        }),
    }),
})

export const { useGetPackagesQuery, useLazyGetPackagesQuery, useGetAllIssueQuery } = packagesSlice
